import { OrderLineTypes } from "@repo/database";
import { generateRandomString } from "@repo/utils";
import { z } from "zod";

import { useCartManager } from "~/managers/use-cart-manager";
import { usePermissionStore } from "~/stores/use-permission-store";
import { Form, FormField, FormItem, useForm } from "../ui/form";
import { Input } from "../ui/input";

export default function OrderCommentForm({ onClose }: { onClose: () => void }) {
  const { addToCart } = useCartManager();

  const { currentEmployee } = usePermissionStore();

  const form = useForm({
    schema: z.object({
      comment: z.string().min(1),
    }),
  });
  const handleSubmit = form.handleSubmit((data) => {
    void addToCart({
      ordered: false,
      printed: false,
      type: OrderLineTypes.comment,
      createdAt: new Date(),
      quantity: 1,
      name: data.comment,
      originalQuantity: 1,
      employeeId: currentEmployee?.id,
      reference: generateRandomString(8),
      value: 0,
      vatRate: 0,
    });
    onClose();
  });

  return (
    <Form {...form}>
      <form
        id="order-comment-form"
        onSubmit={handleSubmit}
        className="flex flex-col gap-2"
      >
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem>
              <Input {...field} />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
